﻿{
  "community": {
    "name": "Community",
    "shortDescription": "Enskilt konto med gratis aktiviteter",
    "features": [
      "Hitta och dela aktiviteter",
      "Obegränsad molnlagring",
      "Åtkomst till premiumaktiviteter"
    ],
    "price": "Gratis",
    "termName": "Livstid"
  },
  "personal": {
    "name": "Personlig prenumeration",
    "shortDescription": "Enskilt konto med anpassade aktiviteter",
    "features": [
      "Skapa och redigera aktiviteter online",
      "Inkluderar en personlig spellista",
      "Åtkomst till aktiviteter när och var som helst"
    ]
  },
  "professional": {
    "name": "Professionell prenumeration",
    "shortDescription": "Enskilt konto med flera elever",
    "features": [
      "Administration av elevuppgifter",
      "Övervaka elevens framsteg",
      "Samarbeta med team-medlemmar."
    ]
  },
  "organization": {
    "name": "Verksamhetsprenumeration",
    "shortDescription": "Flera konton med flera elever",
    "features": [
      "Administration för instruktörer",
      "Rapportering på verksamhetsnivå",
      "Sekretessinställningar för företag"
    ],
    "price": "Kontakta oss",
    "termName": "Villkor 1-5 år"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Förhandsgranskning av skrivbordsredigerare",
    "note": "Prova <1>$t(common:action.free)</1> i 30 dagar!",
    "price": "Gratis",
    "termName": "30 dagars provversion",
    "footerNote": "1 installation"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Komplett skrivbordsredigerare",
    "note": "",
    "termName": "Engångsköp",
    "footerNote": "2 installationer per användare"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Flera licenser för verksamheter",
    "note": "",
    "price": "Kontakta oss",
    "termName": "Mängdrabatter",
    "footerNote": "2 installationer per användare"
  }
}
